"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CompraAhora() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="255814" id="compra-ahora" className="bg-background py-24 md:py-32 lg:py-40 relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`max-w-4xl mx-auto text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6 leading-tight uppercase tracking-wider">
            ¿LISTO PARA TU PRÓXIMA <span className="text-primary">AVENTURA GLOBAL?</span>
          </h2>
          
          <p className="text-foreground/80 text-lg md:text-xl mb-10 max-w-2xl mx-auto font-sans">
            Asegura las mejores ofertas con reserva directa. Tu próximo destino 
            inolvidable está a solo un clic de distancia.
          </p>
          
          <Button asChild className="bg-primary text-primary-foreground hover:bg-accent hover:text-accent-foreground rounded-lg px-8 py-6 text-sm font-bold tracking-widest uppercase transition-colors duration-300 shadow-lg shadow-primary/20">
            <Link to="/SecureYourTalentPage">
              COMPRA AHORA <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
      {/* Subtle travel background imagery element */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1671966/img/travel_world_map_texture.png" alt="" className="w-full h-full object-cover" />
      </div>
    </section>;
}